import React from 'react';
import './Toast.css';

/**
 * Toast - Minimal notification component for transient feedback
 *
 * Used for action failures (e.g., "Could not start session") and
 * confirmation-with-undo flows (e.g., "Highlight dismissed [Undo]" #1050).
 * Positioned fixed at bottom-center, auto-dismisses via ToastContext.
 *
 * @see GitHub Issue #515 (initial), #1050 (action affordance)
 */
function Toast({ message, type = 'error', onDismiss, action = null }) {
  const icon = type === 'error' ? '!' : type === 'success' ? '\u2713' : 'i';

  return (
    <div className={`toast-notification toast-${type}`} role="alert" aria-live="assertive">
      <span className="toast-icon">{icon}</span>
      <span className="toast-message">{message}</span>
      {action && (
        <button
          className="toast-action"
          onClick={action.onClick}
          type="button"
        >
          {action.label}
        </button>
      )}
      <button className="toast-dismiss" onClick={onDismiss} aria-label="Dismiss">&times;</button>
    </div>
  );
}

export default Toast;
